module.exports = __webpack_public_path__ + "img/xiaolv@2x.4dbe111c.png";